/**
 * Feature flags for UI that depends on backend work landing separately.
 * Set `VITE_FEATURE_*=true` in `.env` to enable. Defaults are on so the
 * portal exercises the new endpoints once the API ships them; flip to
 * `false` to hide a feature against an older API.
 */
const read = (key: string, fallback = true): boolean => {
  const raw = (import.meta.env as Record<string, string | undefined>)[key];
  if (raw === undefined || raw === '') return fallback;
  return raw === 'true' || raw === '1';
};

export const features = {
  twoFactor: read('VITE_FEATURE_2FA'),
  notifications: read('VITE_FEATURE_NOTIFICATIONS'),
  googleAuth: read('VITE_FEATURE_GOOGLE_AUTH'),
  sparklines: read('VITE_FEATURE_SPARKLINES'),
  customDomains: read('VITE_FEATURE_CUSTOM_DOMAINS'),
  yearlyBilling: read('VITE_FEATURE_YEARLY_BILLING'),
  shareReport: read('VITE_FEATURE_SHARE_REPORT'),
  globalSearchApi: read('VITE_FEATURE_SEARCH_API'),
  passwordReset: read('VITE_FEATURE_PASSWORD_RESET'),
} as const;

export const APP_NAME = 'CMSH.io';
export const API_DOCS_URL = 'https://api.cmsh.io/docs';
export const STATUS_URL = 'https://status.cmsh.io';
